import { useEffect, useState } from 'react';
import { fetchV2DashboadJobsDetails } from 'common/api/job';
import ReactDataTable from 'common/components/ReactDataTable';

const V2Dashboard = () => {
  const oneIndentation = ' ';
  const [dashboardData, setDashboardData] = useState({
    stuckedJobs: [],
    totalV2LiveJobsCountInFrontend: 0,
    totalV2StuckedJobsCountInEngine: 0,
    daySquareOffJobsCount: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await fetchV2DashboadJobsDetails();
        setDashboardData({
          stuckedJobs: result.stucked_jobs,
          totalV2LiveJobsCountInFrontend: result.total_jobs_in_frontend,
          totalV2StuckedJobsCountInEngine: result.total_jobs_in_engine,
          daySquareOffJobsCount: result.day_squareoff_jobs,
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const columns = [
    { Header: 'Job Id', accessor: 'job_id' },
    { Header: 'Frontend Status', accessor: 'frontend_status' },
  ];

  const {
    stuckedJobs,
    totalV2LiveJobsCountInFrontend,
    totalV2StuckedJobsCountInEngine,
    daySquareOffJobsCount,
  } = dashboardData;

  return (
    <div className="container v2-dashboard bg-white p-4">
      <h5 className="mb-2">Summary</h5>
      <div className="mb-2">
        <span className="badge badge-secondary ml-1">
          V2 Live Jobs in Frontend:
          {oneIndentation}
          {totalV2LiveJobsCountInFrontend}
        </span>
        <span className="badge badge-secondary ml-1">
          V2 Day Squareoff Jobs in Frontend:
          {oneIndentation}
          {daySquareOffJobsCount}
        </span>
        <span className="badge badge-secondary ml-1">
          V2 Live Jobs in Engine:
          {oneIndentation}
          {totalV2StuckedJobsCountInEngine}
        </span>
        <span className="badge badge-secondary ml-1">
          Mismatch:
          {oneIndentation}
          {totalV2LiveJobsCountInFrontend - totalV2StuckedJobsCountInEngine}
        </span>
        <span className="badge badge-secondary ml-1">
          Stucked:
          {oneIndentation}
          {stuckedJobs.length}
        </span>
      </div>
      <h5 className="mb-2">Stucked Job Details</h5>
      <div className="row">
        <div className="col-lg">
          <ReactDataTable columns={columns} data={stuckedJobs} />
        </div>
      </div>
    </div>
  );
};

export default V2Dashboard;
